"use client";

import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "108e1b12d0f5bbd6e965f9f86b9b9f43Tz0xMTExODcsRT0xNzc1ODY1NTk5MDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsUFY9aW5pdGlhbCxLVj0y"
);

export default function MuiXLicense() {
  return null;
}

export enum ISubscription {
  Vaahan = "38ab220e-298e-4a73-ae3b-956ac0e6de7f",
  Dharti = "45b47ec3-7e7a-4482-b08d-c230f16a1d59",
}

enum BaseURL {
  DEV = "https://api-yuj.excellonconnect.com/v3.0/",
  QA = "https://api-qa-yuj.excellonconnect.com/v2.0/",
  UAT = "https://api-uat-yuj.excellonconnect.com/v2.0/",
  LT = "https://lt-identity.excellonconnect.com/v2.0/",
  PROD = "https://idms-identity.excellonconnect.com/v2.0/",
}

export const Config = {
  baseURL: BaseURL.PROD,
  Subscription: ISubscription.Vaahan, // identity
  ClientSecret: "34796d2f-9167-40d2-b0a4-cc2a1926db5b",
  ClientID: "5af4c6cb-e32e-4c40-9e14-5ae6ee38c7a7",
  ApplicationSecret: "23d58939c7b6284eb3a681b2ea5be964",
  ApplicationKey: "3cd5c46b-78f2-4dda-8e43-f10b1272c8ea"
};




